import AppSteps from 'components/views/AppSteps'
import { ReactNode } from 'react'

import Container from '.'

const ContainerWithSteps = ({ children }: { children: ReactNode }) => {
  return <Container sidebarContent={<AppSteps />}>{children}</Container>
}

export default ContainerWithSteps
